module.exports = __webpack_public_path__ + "media/images/footer/europe-hover-87eda41ee386d77d957c5a128ae0a182.png";